var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Status',{attrs:{"value":!_vm.isPrivate,"ok-label":_vm.$t('rooms.public'),"ko-label":_vm.$t('rooms.private')}})
}
var staticRenderFns = []

export { render, staticRenderFns }